// core
import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from "rxjs";
import { startWith, distinctUntilChanged } from 'rxjs/operators';

// services
import { HelpService } from '@open-portal-app/help/services/help.service';

@Component({
  selector: 'app-help-question',
  templateUrl: './help-question.component.html',
  styleUrls: ['./help-question.component.scss']
})
export class HelpQuestionComponent {
  @Input() activeQuestion!: any;
  @Input() form!: FormGroup;
  helpFlow: any;
  userData!: any;
  userDataLoading!: boolean;

  formValueWatcher!: Subscription;

  constructor(
    private helpService: HelpService,
  ) { }

  ngOnInit(): void {
    if (this.activeQuestion) {
      this.formValueWatcher = this.form.valueChanges
        .pipe(
          startWith(this.form.value),
          distinctUntilChanged()
        )
        .subscribe(data => {
          this.actionOnFormChange(data);
        });

      this.activeQuestion.settings.size = this.activeQuestion.key === 'topic' && this.activeQuestion.settings.choices?.length > 4 ? 'small' : 'large';

      this.helpFlow = this.helpService.getHelpflow();
    }
  }

  // Continues to next step when selection changes
  actionOnFormChange(selection: any) {
    let selectedChoiceAction = this.getSelectedChoiceAction(selection[this.activeQuestion.key]);

    // Trigger the next function in service if the answer has changed
    if (selection[this.activeQuestion.key] !== this.activeQuestion.data) {
      this.helpService.next(selection[this.activeQuestion.key], selectedChoiceAction);
    }
  }

  // Continues to next step without changing pre-populated selection
  goToNextStep() {
    this.helpService.next(
      this.activeQuestion.data,
      this.getSelectedChoiceAction(this.activeQuestion.data)
    );
  }

  // Checks what is the action for selected choice
  getSelectedChoiceAction(selectedKey: any) {
    let selectedChoice!: any;
    let selectedChoiceAction!: string;
    if (this.activeQuestion.settings && this.activeQuestion.settings.choices) {
      selectedChoice = this.activeQuestion.settings.choices
      .filter((choice: { key: any; }) => {
          return choice.key === selectedKey;
      });
      selectedChoiceAction = selectedChoice && selectedChoice.length > 0 ? selectedChoice[0].action : '';
    }
    return selectedChoiceAction;
  }
}
